export const getUserInfo = state => state.account.accountDetail;
export const getStatusChangeEmail = state => state.account.statusChangeEmail;
export const getStatusChangePassword = state => state.account.statusChangePassword;
export const getIsLoading = state => state.account.isLoading;
